import { render, staticRenderFns } from "./GatewayRedirect.vue?vue&type=template&id=67407dd7"
import script from "./GatewayRedirect.vue?vue&type=script&lang=js"
export * from "./GatewayRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports